import { render, staticRenderFns } from "./CopyText.vue?vue&type=template&id=049c058a&scoped=true&"
import script from "./CopyText.vue?vue&type=script&lang=ts&"
export * from "./CopyText.vue?vue&type=script&lang=ts&"
import style0 from "./CopyText.vue?vue&type=style&index=0&id=049c058a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049c058a",
  null
  
)

export default component.exports